export const configurationTabs = {
  'Sport' : 'sportTemplates',
  'Bet Types': 'betTypes',
  'Market Types' : 'marketTypes',
  'Bir Delay' : 'birDelay',
  'Risk Categories' : 'riskCategories'
};